import { BuyButtonContent } from './BuyButtonContent';
import { extractUrlParameters } from './urlUtils';
import { ResponseStatus, useProductDetails } from './useProductDetails';
import { getFallbackLevel } from './levelFallbackService';
import { config } from '../../config';

export const PRODUCT_ID_HINT =
    'Please provide a URL parameter "productId" with the id of the related Product in the URL';
export const LEVEL_HINT = 'You have selected a multilevel product. Please add the "level" parameter in the URL';

interface Props {
    userLocale: string;
}

export const BuyButtonWrapper = (props: Props) => {
    const { userLocale } = props;

    const { productId, level, noButton } = extractUrlParameters(window.location.href);

    const effectiveLevel = productId ? getFallbackLevel(productId, level, config.levelFallbackEnabled) : level;

    const { product, status } = useProductDetails({ productId, level: effectiveLevel });
    if (!productId) {
        return <div>{PRODUCT_ID_HINT}</div>;
    }

    if (status === ResponseStatus.missing_level) {
        return <div>{LEVEL_HINT}</div>;
    }

    const showPrice = status === 'success' && !!product && product.bookable;
    const enableButton = ResponseStatus.success === status && product?.bookable;
    const showButton = !noButton;

    return (
        <BuyButtonContent
            userLocale={userLocale}
            showPrice={showPrice}
            showButton={showButton}
            disableButton={!enableButton}
            product={product}
        />
    );
};
